import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';
import Backspace from 'assets/backspace.svg';
import Enter from 'assets/enter.svg';
import ToggleMinus from 'assets/toggle-minus.svg';
import TogglePlus from 'assets/toggle-plus.svg';

export const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  color: ${(p) => p.theme.dark};
  font-weight: 300;
  background-color: ${(p) => p.theme.keyBackground};
  background-repeat: no-repeat;
  border: 1px solid ${(p) => p.theme.keyBorder};
  border-bottom: 0;
  border-right: 0;
  cursor: pointer;
  user-select: none;

  ${injectAdaptive('font-size', ['15px', '17px', '21px', '25px', '27px'])}

  &:active {
    opacity: 0.95;
  }

  &.disabled {
    position: relative;
    pointer-events: none;
    cursor: default;

    &::after {
      position: absolute;
      content: ' ';
      inset: 0;
      opacity: 0.75;
    }
  }

  &.dark {
    background-color: ${(p) => p.theme.keyDarkBackground};
  }

  &.yellow {
    background-color: ${(p) => p.theme.yellow};
  }

  &.green {
    background-color: ${(p) => p.theme.green};
  }

  &.beige {
    background-color: ${(p) => p.theme.beige};

    &::after {
      background-color: ${(p) => p.theme.beige};
    }
  }

  &.sage {
    background-color: ${(p) => p.theme.sage};

    &::after {
      background-color: ${(p) => p.theme.sage};
    }
  }

  &.zero ${Inner} {
    justify-content: start;
    padding-left: 21.5%;
  }

  &.comma {
    text-indent: 5%;
  }

  &.backspace {
    background-image: url('${Backspace}');
    background-position: right 30% center;
    ${injectAdaptive('background-size', ['20%', '22%', '24%', '26%', '28%'])}
  }

  &.enter {
    background-image: url('${Enter}');
    background-position: right 30% bottom 11%;
    ${injectAdaptive('background-size', ['16%', '20%', '23%', '26%', '27%'])}
  }

  &.subtract {
    background-image: url('${ToggleMinus}');
    background-position: right 30% center;
    ${injectAdaptive('background-size', ['12%', '14%', '15%', '17%', '18%'])}
  }

  &.add {
    background-image: url('${TogglePlus}');
    background-position: right 30% center;
    ${injectAdaptive('background-size', ['12%', '14%', '15%', '17%', '18%'])}
  }
`;
